/**
 * URL absoluta a una ruta DE ESTE panel, respetando el prefijo del build.
 *
 * Uruguay se sirve en la raíz del dominio y Perú bajo `/pe/` (ver
 * docs/CLOUDFRONT_RUTAS.md), así que `window.location.origin + '/algo'` desde
 * el panel peruano arma un link que cae en el panel de URUGUAY. Con el link de
 * invitación eso se veía como "enlace de registro inválido": el id del usuario
 * existe en la base de Perú y el back de Uruguay lo responde 404.
 *
 * `import.meta.env.BASE_URL` es el `base` con el que vite compiló: `/pe/` en
 * producción de Perú y `/` en Uruguay y en desarrollo.
 */
export const appUrl = (path: string): string => {
  const base = import.meta.env.BASE_URL || '/';
  const prefix = base.endsWith('/') ? base.slice(0, -1) : base;
  const route = path.startsWith('/') ? path : `/${path}`;
  return `${window.location.origin}${prefix}${route}`;
};
